export enum PopoverSize {
  S = 's',
  M = 'm',
  L = 'l',
}
